<template>
  <div class="list-view content-layout bg-gray">
    <button class="btn btn-primary btn-fab show" @click="scrollToTop()">
      <font-awesome-icon :icon="['fas', 'angle-up']" class="align-middle" />
    </button>
    <button class="btn btn-primary list-side-menu-toggler" :class="{ expand: sideMenuExpanded }"
      @click="() => (sideMenuExpanded = !sideMenuExpanded)">
      <font-awesome-icon :icon="['fas', sideMenuExpanded ? 'times' : 'bars']" />
    </button>
    <div class="list-side-menu" :class="{ expand: sideMenuExpanded, 'overflow-hidden': isLoadingOptions }">
      <loading-spinner class="loading-spinner-component" style="position: fixed; max-width: 300px; left: 0px; top: 70px"
        v-if="isLoadingOptions" />
      <div class="form-group">
        <label class="text-primary">
          <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="mr-2 text-muted" />District
        </label>
        <v-select :clearable="false" placeholder="Select a district" class="report-filter" v-model="models.district"
          :options="options.district" label="name" @input="optionChanged('district')">
          <i slot="spinner" class="icon icon-spinner"></i>
        </v-select>
      </div>
      <div class="form-group">
        <label class="text-primary">
          <font-awesome-icon :icon="['fas', 'bolt']" class="mr-2 text-muted" />Source
        </label>
        <v-select :clearable="false" placeholder="Select a source" class="report-filter" v-model="models.source"
          :disabled="!models.district" :options="options.source.filter(
            (s) => models.district && s.place == models.district._id
          )
            " @input="optionChanged('source')" label="name"></v-select>
      </div>
      <div class="form-group">
        <label class="text-primary">
          <font-awesome-icon :icon="['fas', 'bolt']" class="mr-2 text-muted" />Category
        </label>
        <v-select :clearable="false" placeholder="Select a category" class="report-filter" v-model="models.category"
          :disabled="!models.source" :options="options.category" @input="optionChanged('category')"
          label="name"></v-select>
      </div>
      <div class="form-group">
        <label class="text-primary">
          <font-awesome-icon :icon="['fas', 'bolt']" class="mr-2 text-muted" />Feeder
        </label>
        <v-select :clearable="false" placeholder="Select a feeder" class="report-filter" v-model="models.feeder"
          :disabled="!models.category" :options="options.feeder.filter(
            (f) =>
              models.category &&
              f.category == models.category.name &&
              f.place == models.source._id
          )
            " @input="optionChanged('feeder')" label="name"></v-select>
      </div>
      <div class="form-group">
        <label class="text-primary">
          <font-awesome-icon :icon="['fas', 'calendar-alt']" class="mr-2 text-muted" />Inspection
        </label>
        <v-select :clearable="false" placeholder="Select inspection month" class="report-filter" :options="options.inspection.filter(
          (i) => models.feeder && i.place == models.feeder._id
        )
          " v-model="models.inspection" :disabled="!models.feeder" @input="generateReport()" label="name"></v-select>
      </div>
      <div class="form-group">
        <label class="text-primary">
          <font-awesome-icon :icon="['fas', 'ruler-vertical']" class="mr-2 text-muted" />Pole
        </label>
        <v-select :clearable="true" placeholder="Select a pole" class="report-filter" :options="options.pole.filter(
          (p) => models.inspection && p.inspection == models.inspection._id
        )
          " v-model="models.pole" :disabled="!models.inspection" @input="generateReport()" label="name">
          <i slot="spinner" class="icon icon-spinner"></i>
        </v-select>
      </div>
    </div>
    <div id="reportContent" class="list-main-content position-relative">
      <div class="report-button d-flex justify-content-between align-items-center" v-if="rawPoleReports.length > 0">
        <div>
          <!-- <div class="dropdown d-inline-block mr-3 my-1">
            <button class="btn btn-info btn-sm rounded-pill dropdown-toggle px-3 text-capitalize" type="button"
              id="dropdownMenuButtonStatus" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <font-awesome-icon :icon="['fas', 'certificate']" class="mr-2 align-middle" />
              <span class="d-none d-md-inline mr-2">{{ filters.verification }} Verifications</span>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonStatus">
              <a class="dropdown-item small" href="#" @click.prevent="switchReportVerification('All')">All
                Verification</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item small" href="#" @click.prevent="switchReportVerification('Verified')">Verified
                Defects</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item small" href="#" @click.prevent="switchReportVerification('Unverified')">Unverified
                Defects</a>
            </div>
          </div> -->
          <div class="dropdown d-inline-block mr-3 my-1">
            <button class="btn btn-dark btn-sm rounded-pill dropdown-toggle px-3 text-capitalize" type="button"
              id="dropdownMenuButtonSeverity" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <font-awesome-icon :icon="['fas', 'thermometer-quarter']" class="mr-2 align-middle" />
              <span class="d-none d-md-inline mr-2">{{ filters.severity }} Severity</span>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonSeverity">
              <a class="dropdown-item small" href="#" @click.prevent="switchReportSeverity('All')">All Severity</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item small" href="#" @click.prevent="switchReportSeverity('Low')">Low Severity</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item small" href="#" @click.prevent="switchReportSeverity('Minor')">Minor Severity</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item small" href="#" @click.prevent="switchReportSeverity('Critical')">Critical
                Severity</a>
            </div>
          </div>
          <div class="dropdown d-inline-block mr-3 my-1" v-if="filters.type == 'Defect'">
            <button class="btn btn-dark btn-sm rounded-pill dropdown-toggle px-3 text-capitalize" type="button"
              id="dropdownMenuButtonDefectType" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <font-awesome-icon :icon="['fas', 'filter']" class="mr-2 align-middle" />
              <span class="d-none d-md-inline mr-2">{{ filters.defectType }} Defects</span>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonDefectType">
              <a class="dropdown-item small" href="#" @click.prevent="switchReportDefectType('All')">All Defects</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item small" href="#" @click.prevent="switchReportDefectType('Visual')">Visual
                Defects</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item small" href="#" @click.prevent="switchReportDefectType('Thermal')">Thermal
                Defects</a>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end align-items-center">
          <div class="input-group input-group-sm d-inline-flex" style="max-width: 150px; width: auto"
            v-if="filters.type == 'Daily'">
            <div class="input-group-prepend">
              <label class="input-group-text">
                <font-awesome-icon :icon="['fas', 'calendar-alt']" class="align-middle" />
              </label>
            </div>
            <select class="custom-select" v-model="filters.date">
              <option v-for="pd in poleDates" :key="pd">{{ pd }}</option>
            </select>
          </div>
          <div class="dropdown d-inline-block mx-2">
            <button class="btn btn-primary btn-sm rounded-pill dropdown-toggle px-3" type="button"
              id="dropdownMenuButtonType" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <font-awesome-icon :icon="['fas', 'file-invoice']" class="mr-2 align-middle" />
              <span class="d-none d-md-inline mr-2">{{ filters.type }} Report</span>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonType">
              <a class="dropdown-item small" href="#" @click.prevent="switchReportType('Full')">Full Report</a>
              <div class="dropdown-divider"></div>
              <a v-if="!models.pole" class="dropdown-item small" href="#"
                @click.prevent="switchReportType('Daily')">Daily Report</a>
              <div v-if="!models.pole" class="dropdown-divider"></div>
              <a class="dropdown-item small" href="#" @click.prevent="switchReportType('Defect')">Defect Report</a>
            </div>
          </div>
          <button class="btn btn-sm btn-blue rounded-pill px-3" @click="printReport()">
            <font-awesome-icon :icon="['fas', 'print']" class="mr-md-2 align-middle" />
            <span class="d-none d-md-inline">Print</span>
          </button>
          <button class="btn btn-sm btn-blue rounded-pill px-3 ml-2" @click="downloadReport()">
            <font-awesome-icon :icon="['fas', 'file-excel']" class="mr-md-2 align-middle" />
            <span class="d-none d-md-inline">Excel</span>
          </button>
        </div>
      </div>
      <div class="report-container" v-if="!models.inspection">
        <p class="mb-0 text-center text-muted font-italic">
          Select an inspection to view report
        </p>
      </div>
      <div class="report-container" v-else-if="models.inspection && poleReports.length < 1">
        <p class="mb-0 text-center text-muted font-italic">
          No report available
        </p>
      </div>
      <div class="report-summary" v-else-if="models.inspection && poleReports.length > 0">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <p class="text-primary mb-0">
            <font-awesome-icon :icon="['fas', 'list']" class="mr-2 text-muted" />Summary of defects
          </p>
          <a href="#" @click.prevent="filters.component = null" v-if="filters.component">
            <small>
              <u>Reset Component Filter</u>
            </small>
          </a>
        </div>

        <div class="row">
          <div class="col-6 col-md-4" v-for="defect in defectSummary" :key="defect.name">
            <div class="summary-defect flex-column flex-sm-row clickable"
              :class="{ active: filters.component == defect.name }" @click="switchReportComponent(defect.name)">
              <p class="defect-count mr-sm-3">{{ defect.count }}</p>
              <p class="text-primary text-center text-sm-left">
                {{ defect.name }}
              </p>
              <span class="summary-active">
                <font-awesome-icon :icon="['fas', 'check']" class="text-primary" />
              </span>
            </div>
          </div>
        </div>
        <div v-if="defectSummary.length < 1">
          <div class="summary-defect flex-column flex-sm-row">
            <p class="defect-count mr-sm-3">0</p>
            <p class="text-primary text-center text-sm-left">
              No defect found
            </p>
          </div>
        </div>
      </div>

      <report-sheet-cover :inspection="inspectionInfo" :report-type="filters.type" :defect-type="filters.defectType"
        v-if="models.inspection"></report-sheet-cover>
      <report-sheet-summary :inspection-id="models.inspection._id" sheet-type="visual"
        :summary-table="summaryTable.visual" :category="models.category.name && models.category.name.toLowerCase()"
        v-if="models.inspection && summaryTable.visual.length && filters.defectType !== 'Thermal'"></report-sheet-summary>
      <report-sheet-summary :inspection-id="models.inspection._id" sheet-type="thermal"
        :summary-table="summaryTable.thermal" :category="models.category.name && models.category.name.toLowerCase()"
        v-if="models.inspection && summaryTable.thermal.length && filters.defectType !== 'Visual'"></report-sheet-summary>

      <div v-for="pole in poleReports.slice(currentPage * polePerPage, currentPage * polePerPage + polePerPage)"
        :key="`${pole._id}${renderCounter}`">
        <div class="report-pole-name mt-5 d-flex justify-content-between align-items-center">
          <span class="text-muted">
            # Pole
            <strong class="text-primary">{{ pole.name }}</strong>
          </span>
        </div>
        <report-viewer :district="models.district" :source="models.source.name" :feeder="models.feeder.name"
          :category="models.category.name && models.category.name.toLowerCase()" :pole="pole"
          :poleModel="models.pole ? models.pole._id : null" :filters="filters" :voltage="models.inspection.voltage"
          :load="models.inspection.load" :humidity="models.inspection.humidity"
          :temperature="models.inspection.temperature" :redisRoute="redisRoute" @isLoading="toggleLoading"
          @defectVerified="defectVerified" @toggleModal="toggleModal" />
      </div>
      <div class="report-pager-container d-flex justify-content-center align-items-center text-muted d-print-none"
        v-if="models.inspection && reportPages > 1">
        <div class="py-1 d-flex justify-content-center align-items-center border rounded">
          <div class="px-2 clickable border-right" @click="switchReportPage(0)">
            <font-awesome-icon :icon="['fas', 'angle-double-left']" class="align-middle" />
          </div>
          <div class="px-2 clickable" @click="switchReportPage(currentPage - 1)">
            <font-awesome-icon :icon="['fas', 'angle-left']" class="align-middle" />
          </div>
          <div class="border-left border-right px-2 d-flex justify-content-center align-items-center">
            <div class="px-2 clickable pager-number" :class="{ active: page == currentPage }"
              v-for="(page, index) in computedReportPages" :key="`pager${index}`" @click="switchReportPage(page)">
              {{ page + 1 }}
            </div>
          </div>
          <div class="px-2 clickable" @click="switchReportPage(currentPage + 1)">
            <font-awesome-icon :icon="['fas', 'angle-right']" class="align-middle" />
          </div>
          <div class="px-2 clickable border-left" @click="switchReportPage(reportPages - 1)">
            <font-awesome-icon :icon="['fas', 'angle-double-right']" class="align-middle" />
          </div>
        </div>
      </div>
    </div>
    <gallery-viewer-modal :showModal="modals.galleryViewer" :images="galleryImages" :caption="galleryCaption"
      :currentImageIndex="galleryIndex" @toggleModal="toggleModal"></gallery-viewer-modal>
  </div>
</template>

<script>
import API from "@/api.js";
import moment from "moment";
import { saveAs } from "file-saver";
import LoadingSpinner from "@/components/LoadingSpinner";
import GalleryViewerModal from "@/modals/GalleryViewer";
import ReportViewer from "@/components/ReportViewer";
import ReportSheetCover from "@/components/ReportSheetCover.vue";
import ReportSheetSummary from "@/components/ReportSheetSummary";

export default {
  name: "listView2",
  components: {
    "loading-spinner": LoadingSpinner,
    "report-viewer": ReportViewer,
    "gallery-viewer-modal": GalleryViewerModal,
    "report-sheet-summary": ReportSheetSummary,
    "report-sheet-cover": ReportSheetCover
  },
  data() {
    return {
      renderCounter: 0,
      sideMenuExpanded: false,
      isLoadingOptions: false,
      modals: {
        galleryViewer: false,
      },
      galleryImages: [],
      galleryIndex: 0,
      galleryCaption: null,
      options: {
        district: [],
        source: [],
        category: [],
        feeder: [],
        inspection: [],
        pole: [],
      },
      models: {
        district: null,
        source: null,
        category: null,
        feeder: null,
        inspection: null,
        pole: null,
      },
      defectSummary: [],
      rawPoleReports: [],
      poleReports: [],
      poleDates: [],
      reportPages: 0,
      currentPage: 0,
      polePerPage: 10,
      filters: {
        defectType: "All",
        verification: "All",
        severity: "All",
        type: "Full",
        component: null,
        date: null,
      },
      redisRoute: null,
      user: JSON.parse(localStorage.getItem("user")),
      summaryTable: { visual: [], thermal: [] },
      inspectionInfo: {}
    };
  },
  watch: {
    currentPage: {
      handler() {
        if (this.models.source) {
          document.title = `${this.models.source.name} - Page ${this.currentPage + 1}`;
        }
      },
      immediate: true,
    },
    models: {
      handler() {
        let item = Object.keys(this.models)
          .filter((x) => x != "pole")
          .reduce((obj, key) => {
            obj[key] = this.models[key];
            return obj;
          }, {});

        localStorage.setItem("models", JSON.stringify(item));

        this.switchReportVerification("All");
        this.switchReportSeverity("All");
        this.switchReportType("Full");

        this.$nextTick(() => {
          this.scrollToTop();
        });
      },
      deep: true,
    },
    filters: {
      handler() {
        this.$emit("isLoading", true);

        this.$nextTick(() => {
          let pr = JSON.parse(JSON.stringify(this.rawPoleReports));

          if (this.filters.severity !== "All") {
            let newPr = [];
            pr.forEach((r) => {
              let newR = [];
              r.defects.forEach((def) => {
                if (
                  def.severity ==
                  (this.filters.severity == "Minor" ||
                    this.filters.severity == "Cautious"
                    ? "minor"
                    : this.filters.severity.toLowerCase())
                ) {
                  newR.push(def);
                }
              });
              r.defects = newR;
              newPr.push(r);
            });

            pr = newPr.filter((n) => n.defects.length > 0);
          }

          if (this.filters.type !== "Defect") {
            this.filters.defectType = "All";
          }

          if (this.filters.defectType !== "All") {
            let newPr = [];
            pr.forEach((r) => {
              let newR = [];
              r.defects.forEach((def) => {
                if (def.type == this.filters.defectType.toLowerCase()) {
                  newR.push(def);
                }
              });
              r.defects = newR;
              newPr.push(r);
            });

            pr = newPr.filter((n) => n.defects.length > 0);
          }

          if (this.filters.type == "Defect") {
            let newPr = [];
            pr.forEach((r) => {
              let newR = r.defects.filter((nr) => nr.severity !== "notify");
              r.defects = newR;
              newPr.push(r);
            });

            pr = newPr.filter((n) => n.defects.length > 0);
          }

          if (this.filters.verification == "Verified") {
            let newPr = [];
            pr.forEach((r) => {
              let newR = [];
              r.defects.forEach((def) => {
                if (
                  this.getDefectVerificationStatus(def.ilsas_verify) == true &&
                  this.getDefectVerificationStatus(def.sesb_verify) == true
                ) {
                  newR.push(def);
                }
              });
              r.defects = newR;
              newPr.push(r);
            });

            pr = newPr.filter((n) => n.defects.length > 0);
          } else if (this.filters.verification == "Unverified") {
            let newPr = [];
            pr.forEach((r) => {
              let newR = [];
              r.defects.forEach((def) => {
                if (
                  !this.getDefectVerificationStatus(def.ilsas_verify) ||
                  !this.getDefectVerificationStatus(def.sesb_verify)
                ) {
                  newR.push(def);
                }
              });
              r.defects = JSON.parse(JSON.stringify(newR));
              newPr.push(r);
            });

            pr = newPr.filter((n) => n.defects.length > 0);
          }

          if (this.filters.type == "Daily" && this.filters.date) {
            let newPr = [];
            pr.forEach((r) => {
              let newR = [];
              if (
                moment.utc(r.datetime).format("YYYY-MM-DD") ==
                moment.utc(this.filters.date).format("YYYY-MM-DD")
              ) {
                newPr.push(r);
              }
            });

            pr = newPr.filter((n) => n.defects.length > 0);
          }

          if (this.filters.type != "Full") {
            let newPr = [];
            pr.forEach((r) => {
              let newR = r.defects.filter((d) => d.component != "Observations");
              r.defects = JSON.parse(JSON.stringify(newR));
              newPr.push(r);
            });

            pr = newPr.filter((n) => n.defects.length > 0);
          }

          if (this.filters.component) {
            let newPr = [];
            pr.forEach((r) => {
              let newR = [];
              r.defects.forEach((def) => {
                if (
                  def.component &&
                  def.component.toLowerCase() ==
                  this.filters.component.toLowerCase()
                ) {
                  newR.push(def);
                }
              });
              r.defects = JSON.parse(JSON.stringify(newR));
              newPr.push(r);
            });

            pr = newPr.filter((n) => n.defects.length > 0);
          }

          this.countDefectSummary(pr);
          this.countReportPages(pr.length);
          this.poleReports = pr;

          this.$nextTick(() => {
            this.$emit("isLoading", false);
          });
        });
      },
      deep: true,
    },
  },
  computed: {
    computedReportPages() {
      if (this.reportPages <= 5) {
        let rp = [];
        for (let index = 0; index < this.reportPages; index++) {
          rp.push(index);
        }
        return rp;
      } else {
        let rp = [];
        let idx = this.currentPage - 2 < 0 ? 0 : this.currentPage - 2;
        let maxIdx = idx + 5 > this.reportPages ? this.reportPages : idx + 5;
        for (let index = idx; index < maxIdx; index++) {
          rp.push(index);
        }
        return rp;
      }
    },
  },
  methods: {
    downloadReport() {
      if (!this.models.category) return;

      this.$emit("isLoading", true);

      let qrType = this.models.category.name.toLowerCase();
      if (qrType !== 'lv') qrType = 'hv';

      let url = `inspections/download-qr/${this.models.inspection._id}?type=${qrType}`;

      API.get(url, 'file')
        .then((retVal) => {
          const blob = retVal.data;
          const contentDisposition = retVal.headers['content-disposition'];
          let fileName = 'QR03.xlsx';

          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
              fileName = match[1];
            }
          }

          if (blob) {
            saveAs(blob, fileName);
          }

          this.$emit("isLoading", false);
        })
        .catch((err) => {
          console.error(err);
          this.$emit("isLoading", false);
        });
    },
    getSummaryTable() {
      this.$emit("isLoading", true);

      this.summaryTable = { visual: [], thermal: [] };

      return new Promise((resolve, reject) => {
        let url = `inspections/download-qr/${this.models.inspection._id}?type=cover`;

        API.get(url)
          .then((retVal) => {
            const st = JSON.parse(JSON.stringify(retVal.data));

            const chunkArray = (arr) => {
              const size = 20;
              const result = [];

              for (let i = 0; i < arr.length; i += size) {
                result.push(arr.slice(i, i + size));
              };

              return result;
            };

            Object.keys(st).forEach(key => {
              st[key] = chunkArray(st[key]);
            });

            this.summaryTable = st;

            this.$emit("isLoading", false);

            resolve();
          })
          .catch((err) => {
            console.error(err);
            this.$emit("isLoading", false);

            reject(err);
          });
      });
    },
    getInspectionInfo() {
      this.$emit("isLoading", true);

      this.inspectionInfo = {};

      return new Promise((resolve, reject) => {
        let url = `inspections/${this.models.inspection._id}`;

        API.get(url)
          .then((retVal) => {
            this.inspectionInfo = retVal.data;

            this.$emit("isLoading", false);

            resolve();
          })
          .catch((err) => {
            console.error(err);
            this.$emit("isLoading", false);
            reject(err);
          });
      });
    },
    toggleLoading(show) {
      this.$emit("isLoading", show);
    },
    getDefectVerificationStatus(v) {
      if (v) {
        return true;
      } else {
        return false;
      }
    },
    printReport() {
      this.$nextTick(() => {
        window.print();
      });
    },
    switchReportPage(page) {
      if (page < 0) {
        page = 0;
      } else if (page > this.reportPages - 1) {
        page = this.reportPages - 1;
      }

      if (this.currentPage != page) {
        this.currentPage = page;
        this.$nextTick(() => {
          this.scrollToTop();
        });
      }
    },
    scrollToTop() {
      let reportContent = document.getElementById("reportContent");

      if (reportContent) {
        reportContent.scrollTop = 0;
      }
    },
    switchReportDefectType(defectType) {
      this.filters.defectType = defectType;
    },
    switchReportComponent(type) {
      if (this.filters.component == type) {
        this.filters.component = null;
      } else {
        this.filters.component = type;
      }
    },
    switchReportSeverity(type) {
      this.filters.severity = type;
    },
    switchReportType(type) {
      this.filters.type = type;

      if (type == "Daily") {
        this.filters.date = this.poleDates[this.poleDates.length - 1];
      } else {
        this.filters.date = null;
      }
    },
    switchReportVerification(type) {
      this.filters.verification = type;
    },
    async generateReport(dontJump) {
      await this.getInspectionInfo();
      await this.getSummaryTable();

      this.$emit("isLoading", true);

      let url = `report/${this.models.inspection._id}`;

      if (this.models.pole) {
        url += `?poleId=${this.models.pole._id}`;

        if (this.filters.type == "Daily") {
          this.filters.type = "Full";
        }
      }

      this.redisRoute = url;

      API.get(url)
        .then((retVal) => {
          this.countDefectSummary(retVal.data);
          this.getPoleReports(retVal.data);

          if (!dontJump) {
            this.countReportPages(retVal.data.length);

            this.$nextTick(() => {
              this.scrollToTop();
            });
          }

          this.$emit("isLoading", false);
        })
        .catch((err) => {
          console.error(err);
          this.$emit("isLoading", false);
        });
    },
    countReportPages(polesLength) {
      this.reportPages = Math.ceil(polesLength / this.polePerPage);
      this.currentPage = 0;
    },
    countDefectSummary(poles) {
      this.defectSummary = [];
      poles.forEach((d) => {
        d.defects.forEach((def) => {
          let x = this.defectSummary.find((df) => df.name == def.component);
          if (x) {
            x.count++;
          } else {
            this.defectSummary.push({
              name: def.component,
              count: 1,
            });
          }
        });
      });

      this.defectSummary.sort((a, b) => {
        let aString = a.name;
        let bString = b.name;

        return aString < bString ? -1 : 1;
      });
    },
    getPoleReports(poles) {
      this.rawPoleReports = poles;

      this.poleDates = [];

      this.rawPoleReports.forEach((pr) => {
        let d = moment.utc(pr.datetime).format("YYYY-MM-DD");
        if (!this.poleDates.includes(d)) {
          this.poleDates.push(d);
        }
      });

      this.poleDates.sort();

      this.rawPoleReports.sort((a, b) => {
        let aNum = parseInt(a.name.split(" ")[0]);
        let bNum = parseInt(b.name.split(" ")[0]);

        return aNum - bNum;
      });

      this.poleReports = JSON.parse(JSON.stringify(this.rawPoleReports));

      document.title = `${this.models.source.name} - Page ${this.currentPage + 1
        }`;
    },
    async defectVerified(e) {
      let pole = this.rawPoleReports.find((r) => r._id == e.pole._id);

      let rawPoleIndex = this.rawPoleReports.findIndex(
        (r) => r._id == pole._id
      );

      let poleIndex = this.poleReports.findIndex((r) => r._id == pole._id);
      let defectIndex = pole.defects.findIndex((d) => d._id == e._id);

      e.defectImages =
        e.defectImages && e.defectImages.length > 0
          ? e.defectImages
            .map((i) => {
              return {
                _id: i._id,
                name: i.name,
                url: i.url,
              };
            })
            .sort((a, b) => {
              return a.name < b.name;
            })
          : [];

      delete e.maintenanceImages;

      pole.defects[defectIndex] = e;

      this.$nextTick(() => {
        this.$set(this.rawPoleReports, rawPoleIndex, pole);
        this.$set(this.poleReports, poleIndex, pole);

        this.renderCounter += 1;

        this.$emit("isLoading", false);
      });
    },
    toggleModal(name, show, images, index, caption) {
      if (name == "galleryViewer") {
        this.modals.galleryViewer = show;
        this.galleryImages = show ? images : [];
        this.galleryIndex = show ? index : 0;
        this.galleryCaption = show ? caption : null;
      }
    },
    async fetchOptions() {
      return new Promise((resolve, reject) => {
        this.isLoadingOptions = true;

        API.get("options/sidebar")
          .then((retVal) => {
            this.options = retVal.data;
            this.options.district = retVal.data.district.filter(d => d.users.map(u => u.id).length)

            this.isLoadingOptions = false;

            resolve();
          })
          .catch((err) => {
            console.error(err);

            this.isLoadingOptions = false;

            reject();
          });
      });
    },
    optionChanged(type) {
      this.poleReports = [];
      this.rawPoleReports = [];

      let typeIndex = Object.keys(this.options).findIndex((key) => key == type);

      Object.keys(this.options).forEach((key, index) => {
        if (index > typeIndex) {
          this.models[key] = null;
        }
      });
    },
  },
  async mounted() {
    await this.fetchOptions();

    const ls = localStorage.getItem("models");

    if (ls) {
      const models = JSON.parse(ls);

      Object.keys(models).forEach((key) => {
        if (models[key]) {
          this.models[key] = models[key];

          if (key == "inspection") {
            if (this.$route.query && this.$route.query.poleId) {
              this.models.pole = this.options.pole.find(
                (p) => p._id == this.$route.query.poleId
              );

              this.$router.replace({
                query: {},
              });
            }

            this.generateReport();
          }
        }
      });
    }
  },
  beforeDestroy() {
    document.title = 'Powerline Inspection';
  }
};
</script>
